/** Accept only canonical same-club relative locations, never protocol/host URLs. */
export function frontDeskReturnLocation(candidate, clubCode) {
  const fallback = `/${clubCode}/profile`
  if (typeof candidate !== 'string' || /[\\\u0000-\u0020]/.test(candidate)) return fallback
  try {
    const base = 'https://members.invalid'
    const url = new URL(candidate, base)
    if (!candidate.startsWith(`/${clubCode}/`) || url.origin !== base) return fallback
    if (!url.pathname.startsWith(`/${clubCode}/`) || url.pathname === `/${clubCode}/contact-front-desk`) return fallback
    return `${url.pathname}${url.search}${url.hash}`
  } catch { return fallback }
}
